export const formatDate = (dateString) => {
  if (!dateString) return "-";
  return new Date(dateString).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const formatDateRangeForAPI = (start, end) => {
  const startDate = new Date(start);
  startDate.setHours(0, 0, 0, 0);

  const endDate = new Date(end);
  endDate.setHours(23, 59, 59, 999);

  return {
    start_date: startDate.toISOString(),
    end_date: endDate.toISOString(),
  };
};

export const getDefaultMonthToDateRange = () => {
  const now = new Date();
  return [new Date(now.getFullYear(), now.getMonth(), 1), now];
};

export const isDateRangeSelected = (range) => !!(range && range[0] && range[1]);

export const formatBucketLabel = (dateStr, granularity, full = false) => {
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  if (granularity === "month") return d.toLocaleDateString(undefined, { month: "short", year: "2-digit" });
  if (granularity === "week") {
    return full
      ? `Week of ${d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}`
      : d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
  }
  return full
    ? d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" })
    : d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
};

export const periodLabelFor = (range) => {
  if (!isDateRangeSelected(range)) return "this period";
  const diffDays = Math.round((range[1] - range[0]) / (1000 * 60 * 60 * 24));
  if (diffDays <= 1) return "today";
  if (diffDays <= 7) return "this week";
  if (diffDays <= 31) return "this month";
  if (diffDays <= 100) return "this quarter";
  if (diffDays <= 370) return "this year";
  return "this period";
};

export const timeAgo = (dateStr) => {
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return "";
  const diffMs = Date.now() - d.getTime();
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  if (diffHours < 1) return "Just now";
  if (diffHours < 24) return `${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 7) return `${diffDays} days ago`;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
};
